import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 35px;
  width: 190px;
  font-size: 14px;
  background: #ffffff;
  text-align: center;
  border-radius: 4px;
`;

export const TimerIcon = styled.div`
  height: 22px;
  width: 22px;
  background: url('/img/timer.png') no-repeat center center;
`;
